<template>
  <header class="site-header" :class="{ 'scrolled': scrolled }">
    <div class="container">
      <a href="#home" class="site-header__logo" @click.prevent="scrollToSection('home')">
        <svg class="site-header__logo-icon" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="2" y="2" width="32" height="32" rx="6" fill="var(--sage-dark)" />
  <path d="M6 18L18 8L30 18" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10 16V28H26V16" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14 28V20H22V28" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
        昌乐通达钢结构集成房屋
      </a>

      <nav class="site-header__nav" :class="{ 'site-header__nav--open': menuOpen }">
        <a href="#home" :class="{ active: activeSection === 'home' }" @click.prevent="scrollToSection('home')">{{ locale === 'zh' ? '首页' : 'Home' }}</a>
        <a href="#about" :class="{ active: activeSection === 'about' }" @click.prevent="scrollToSection('about')">{{ locale === 'zh' ? '关于我们' : 'About' }}</a>
        <a href="#products" :class="{ active: activeSection === 'products' }" @click.prevent="scrollToSection('products')">{{ locale === 'zh' ? '产品展示' : 'Products' }}</a>
        <!-- <a href="#quality" :class="{ active: activeSection === 'quality' }" @click.prevent="scrollToSection('quality')">{{ locale === 'zh' ? '品质管控' : 'Quality' }}</a> -->
        <a href="#process" :class="{ active: activeSection === 'process' }" @click.prevent="scrollToSection('process')">{{ locale === 'zh' ? '服务流程' : 'Process' }}</a>
        <a href="#contact" :class="{ active: activeSection === 'contact' }" @click.prevent="scrollToSection('contact')">{{ locale === 'zh' ? '联系我们' : 'Contact' }}</a>
        <router-link to="/news" :class="{ active: activeSection === 'news' }">{{ locale === 'zh' ? '新闻资讯' : 'News' }}</router-link>
      </nav>

      <div class="site-header__actions">
        <button v-if="enableLangSwitch" class="lang-btn" @click="$emit('toggle-language')">
          {{ locale === 'zh' ? 'EN' : '中文' }}
        </button>
        <button class="site-header__burger" :class="{ open: menuOpen }" @click="menuOpen = !menuOpen" aria-label="Menu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    currentLocale: { type: String, default: 'zh' }
  },
  data() {
    return {
      locale: this.currentLocale,
      menuOpen: false,
      activeSection: 'home',
      scrolled: false,
      enableLangSwitch: true
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    scrollToSection(id) {
      this.menuOpen = false
      const el = document.getElementById(id)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        this.activeSection = id
      } else if (this.$route && this.$route.path !== '/') {
        this.$router.push({ name: 'Home' }).then(() => {
          const timer = setInterval(() => {
            const target = document.getElementById(id)
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' })
              this.activeSection = id
              clearInterval(timer)
            }
          }, 50)
          setTimeout(() => clearInterval(timer), 2000)
        })
      }
    },
    handleScroll() {
      this.scrolled = window.scrollY > 20
      const sections = ['home', 'about', 'products', 'quality', 'process', 'contact', 'news']
      const pos = window.scrollY + 100
      for (const s of sections) {
        const el = document.getElementById(s)
        if (el && pos >= el.offsetTop && pos < el.offsetTop + el.offsetHeight) {
          this.activeSection = s
          break
        }
      }
    }
  },
  watch: {
    currentLocale(v) { this.locale = v }
  }
}
</script>

<style scoped>
.site-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--nav-height, 64px);
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid transparent;
  transition: border-color 0.3s var(--ease), box-shadow 0.3s var(--ease);
}

.site-header.scrolled {
  border-bottom-color: var(--border-color);
  box-shadow: var(--shadow-sm);
}

.site-header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  max-width: var(--max-width, 1200px);
  margin: 0 auto;
  padding: 0 2rem;
}

.site-header__logo {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-family: var(--font-serif);
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--bark);
  letter-spacing: 0.02em;
  flex-shrink: 0;
}

.site-header__logo-icon {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
}

.site-header__nav {
  display: flex;
  align-items: center;
  gap: 2px;
}

.site-header__nav a {
  padding: 0.5rem 1rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--stone);
  border-radius: var(--radius-sm);
  transition: color 0.2s var(--ease), background 0.2s var(--ease);
  white-space: nowrap;
}

.site-header__nav a:hover {
  color: var(--bark);
  background: rgba(74, 63, 53, 0.04);
}

.site-header__nav a.active {
  color: var(--sage-dark);
  background: rgba(122, 142, 106, 0.08);
}

.site-header__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.lang-btn {
  background: none;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  padding: 0.4rem 0.75rem;
  font-size: 0.78rem;
  font-weight: 500;
  color: var(--stone);
  cursor: pointer;
  font-family: var(--font-sans);
  transition: all 0.2s var(--ease);
}

.lang-btn:hover {
  border-color: var(--sage-dark);
  color: var(--sage-dark);
}

.site-header__burger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  -webkit-tap-highlight-color: transparent;
}

.site-header__burger span {
  display: block;
  width: 22px;
  height: 2px;
  background: var(--bark);
  border-radius: 1px;
  transition: all 0.25s var(--ease);
}

.site-header__burger.open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.site-header__burger.open span:nth-child(2) {
  opacity: 0;
}

.site-header__burger.open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

@media (max-width: 768px) {
  .site-header .container {
    padding: 0 1.25rem;
  }

  .site-header__nav {
    display: none;
  }

  .site-header__burger {
    display: flex;
  }

  .site-header__nav--open {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: var(--nav-height, 56px);
    left: 0;
    width: 100%;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--border-color);
    padding: 0.5rem 0;
    box-shadow: var(--shadow-md);
    max-height: calc(100dvh - var(--nav-height, 56px));
    overflow-y: auto;
  }

  .site-header__nav--open a {
    width: 100%;
    padding: 0.9rem 1.5rem;
    border-radius: 0;
    font-size: 0.9rem;
  }
}
</style>